<template>
  <div>
    <h3>{{ $t('randevu.stats.daily_chart.title') }}</h3>
    <div class="range-btns">
      <button
        style="min-width: 4rem;"
        v-for="opt in ranges"
        :key="opt.key"
        :class="{ active: selectedRange === opt.key }"
        @click="changeRange(opt.key)"
      >
        {{ $t(opt.labelKey) }}
      </button>
    </div>
    <div class="chart-wrapper">
      <Line v-if="chartData" :data="chartData" :options="chartOptions" />
      <p v-else>{{ $t('common.loading') }}</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { Line } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale
)

export default {
  name: 'DailyCompletedLineChart',
  components: { Line },
  data () {
    return {
      rawData: [],
      chartData: null,
      selectedRange: '1m',
      ranges: [
        { key: '1y', labelKey: 'randevu.stats.daily_chart.range_1y', days: 365 },
        { key: '6m', labelKey: 'randevu.stats.daily_chart.range_6m', days: 182 },
        { key: '3m', labelKey: 'randevu.stats.daily_chart.range_3m', days: 91 },
        { key: '1m', labelKey: 'randevu.stats.daily_chart.range_1m', days: 30 }
      ],
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        elements: { line: { tension: 0.3 } },
        interaction: { intersect: false, mode: 'index' },
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              title: items => items[0].label,
              label: ctx => `${this.$t('randevu.stats.daily_chart.tooltip_total')} ${ctx.formattedValue}`
            }
          }
        },
        scales: {
          x: {
            ticks: { display: false },
            grid: { display: false }
          },
          y: {
            beginAtZero: true,
            ticks: {
              stepSize: 1,
              callback: v => v
            }
          }
        }
      }
    }
  },
  async created () {
    const { data } = await axios.get('/promo/user/stats/daily-completed-last-year')
    this.rawData = data.map(d => ({ date: d.date, total: Math.max(d.total, 0) }))
    this.updateChart()
  },
  methods: {
    changeRange (key) {
      this.selectedRange = key
      this.updateChart()
    },
    updateChart () {
      const { days } = this.ranges.find(r => r.key === this.selectedRange)
      const slice = this.rawData.slice(-days)
      this.chartData = {
        labels: slice.map(d => d.date),
        datasets: [{
          label: this.$t('randevu.stats.daily_chart.dataset_label'),
          data: slice.map(d => d.total),
          borderColor: '#187774',
          backgroundColor: 'rgba(24,119,116,0.20)',
          pointRadius: 0
        }]
      }
    }
  }
}
</script>

<style scoped>
.range-btns {
  margin-bottom: 6px;
  display: flex;
  gap: 6px;
}
.range-btns button {
  padding: 4px 6px;
  border: 1px solid #187774;
  background: transparent;
  color: #187774;
  cursor: pointer;
  border-radius: 4px;
}
.range-btns .active {
  background: #187774;
  color: #fff;
}
.chart-wrapper {
  max-height: 320px;
  position: relative;
}
.chart-wrapper canvas {
  max-height: 320px !important;
}
</style>
